import {
  Box,
  Text,
  VStack,
  HStack,
  Flex,
  Avatar,
  Button,
  Icon,
  Grid,
  Tooltip,
} from '@chakra-ui/react'
import {useDispatch, useSelector} from 'react-redux'
import learnPartTwoRequest from '@apis/learn-part-two'
import {useEffect, useState} from 'react'
import {
  updateMessages,
  updateIsShowSampleAnswer,
  updateIsLoadingBot,
  updateAudio,
} from '@redux/learn-part-two/learnPartTwo'
import {CommonColors} from '@utils/CommonStyles'
import {styleByTextTag} from '@utils'
import {ReactComponent as SaveTrueIcon} from '@assets/svgs/save_true.svg'
import {ReactComponent as SaveFalseIcon} from '@assets/svgs/save_false.svg'
import {
  updateIsShowSavePhraseForm,
  updatePhraseToSave,
} from '@redux/shared/shared'
import SavePhraseForm from '@components/SavePhraseForm'
import UserMsg from './UserMsg'
import {BsExclamationCircle} from 'react-icons/bs'
import {ReactComponent as EyeIcon} from '@assets/svgs/eye.svg'
import AvatarDefault from '@assets/images/avatar-msg-part-two.png'

const Summary = ({
  sessionId,
  currentContent,
}: {
  sessionId: string
  currentContent: any
}) => {
  const {messages, isShowSampleAnswer, isLoadingBot} = useSelector(
    (state: any) => state.learnPartTwo,
  )
  const {phraseToSave} = useSelector((state: any) => state.shared)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [isSaveSentence, setIsSaveSentence] = useState<boolean>(false)
  const [isSave, setIsSave] = useState<any>({})

  const dispatch = useDispatch()

  useEffect(() => {
    getSummary()
  }, [])

  const getSummary = async () => {
    dispatch(updateIsLoadingBot(true))
    const params = {
      session_id: sessionId,
    }
    const res = await learnPartTwoRequest.getSummary(params)
    setTimeout(() => {
      dispatch(updateIsShowSampleAnswer(false))
    }, 5000)
    const botMsg = {
      type: 'BOT',
      content: currentContent?.introduction,
    }
    const outlineMsg = {
      type: 'OUTLINE',
      origin_ideas: res?.data?.data?.origin_ideas,
      bot_suggestion: res?.data?.data?.bot_suggestion?.data,
    }
    setIsLoading(false)
    dispatch(updateIsLoadingBot(false))
    dispatch(updateMessages([botMsg, outlineMsg]))

    const audioData = {
      time: Date.now(),
      url: currentContent?.introduction_audio,
    }

    dispatch(updateAudio(audioData))
  }

  const handleSaveSentence = () => {
    if (isSaveSentence) return
    setIsSaveSentence(true)
  }

  const handleSavePhrase = async (item: any) => {
    dispatch(updateIsShowSavePhraseForm(true))
    dispatch(updatePhraseToSave(item.text_en))
  }

  const handleAfterSuccess = () => {
    setIsSave((pre: any) => ({
      ...pre,
      [phraseToSave.replace(/ /g, '_')]: true,
    }))
  }

  const renderMessage = (msg: any, index: any) => {
    switch (msg?.type) {
      case 'BOT':
        return (
          <HStack key={index} align="start" spacing={4}>
            <Avatar
              src={AvatarDefault}
              size="sm"
              borderRadius={'50%'}
              border={'2px solid #E4E7EC'}
            />
            <VStack
              maxWidth={'80%'}
              align="start"
              spacing={4}
              bg={'white'}
              p={'16px'}
              borderRadius={'12px'}>
              <Text fontSize={'16px'}>{msg?.content}</Text>
            </VStack>
          </HStack>
        )
      case 'USER':
        return <UserMsg key={index} msg={msg} />
      case 'OUTLINE':
        return (
          <HStack key={index} align="start" spacing={4}>
            <Avatar
              src={AvatarDefault}
              size="sm"
              borderRadius={'50%'}
              border={'2px solid #E4E7EC'}
            />
            <VStack
              maxWidth={'80%'}
              align="start"
              spacing={4}
              bg={'white'}
              p={'16px'}
              borderRadius={'12px'}>
              <Text
                fontSize={'18px'}
                w={'100%'}
                textAlign={'center'}
                color={CommonColors.primary}>
                {isShowSampleAnswer
                  ? 'Câu trả lời mẫu'
                  : 'Cố gắng nói theo dàn ý mà không nhìn mẫu nhé!'}
              </Text>
              <Flex flexDirection={'column'} gap={4} mt={4}>
                {isShowSampleAnswer ? (
                  <>
                    {msg?.bot_suggestion?.map((item: any, index: number) => (
                      <Flex key={index} gap={4}>
                        <Text
                          flexShrink={0}
                          w={'120px'}
                          color={'#667085'}
                          fontSize={'16px'}
                          textTransform={'uppercase'}>
                          {item?.title}
                        </Text>
                        <Text color={'#101828'} fontSize={'16px'}>
                          {styleByTextTag(item?.answer)}
                        </Text>
                      </Flex>
                    ))}
                  </>
                ) : (
                  <>
                    {msg?.origin_ideas?.map((item: any, index: number) => (
                      <Flex key={index} gap={4}>
                        <Text
                          flexShrink={0}
                          w={'120px'}
                          color={'#667085'}
                          fontSize={'14px'}
                          textTransform={'uppercase'}>
                          {item?.title}
                        </Text>
                        <Flex flexDirection={'column'} gap={2}>
                          {item?.answer?.map((idea: any, index: number) => (
                            <Text
                              key={index}
                              color={'#101828'}
                              fontSize={'16px'}>
                              <Text as={'span'} mr={2}>
                                •
                              </Text>
                              {idea}
                            </Text>
                          ))}
                        </Flex>
                      </Flex>
                    ))}
                  </>
                )}
              </Flex>
              {!isShowSampleAnswer && (
                <Flex justifyContent={'center'} w={'100%'} mt={4}>
                  <Button
                    rightIcon={<EyeIcon />}
                    color={CommonColors.primary}
                    variant={'outline'}
                    borderColor={CommonColors.primary}
                    onClick={() => dispatch(updateIsShowSampleAnswer(true))}>
                    Cứ đọc theo mẫu đấy
                  </Button>
                </Flex>
              )}
            </VStack>
          </HStack>
        )
      case 'SCORE':
        return (
          <HStack key={index} align="start" spacing={4}>
            <Avatar
              src={AvatarDefault}
              size="sm"
              borderRadius={'50%'}
              border={'2px solid #E4E7EC'}
            />
            <VStack
              maxWidth={'80%'}
              align="start"
              spacing={4}
              bg={'white'}
              p={'16px'}
              borderRadius={'12px'}>
              <Flex alignItems="center" gap={2} fontWeight={600}>
                <Text fontSize={'16px'}>Mình dự đoán bài nói của bạn</Text>
                <Text fontSize={'18px'} color="blue.500" fontWeight="600">
                  đạt {msg?.overall.toFixed(1)}
                </Text>
                <Text fontSize={'16px'}>trên band điểm IELTS</Text>
                <Tooltip label="Phần điểm mang tính chất tham khảo. Để biết điểm chính xác hơn, hãy sử dụng phần thi thử.">
                  <Box>
                    <Icon
                      as={(BsExclamationCircle as any) || <></>}
                      color="#98A2B3"
                      boxSize="20px"
                      cursor="pointer"
                    />
                  </Box>
                </Tooltip>
              </Flex>
              <Text color="gray.500" fontSize={'16px'}>
                Hãy xem nhận xét chi tiết ở dưới để cải thiện thêm
              </Text>

              <Grid templateColumns="repeat(2, 1fr)" gap={4} w="full">
                <VStack align="start">
                  <Text color="blue.400" fontWeight="600" fontSize={'16px'}>
                    FLUENCY & COHERENCE
                  </Text>
                  {msg?.fluency
                    ?.split('-')
                    .filter((point: string) => point.trim())
                    .map((point: string, idx: number) => (
                      <Text key={idx} fontSize={'16px'}>
                        - {point.trim()}
                      </Text>
                    ))}
                </VStack>

                <VStack align="start">
                  <Text color="blue.400" fontWeight="600" fontSize={'16px'}>
                    VOCABULARY
                  </Text>
                  <Text fontSize={'16px'}>
                    {msg?.vocabulary
                      ?.split('-')
                      .filter((point: string) => point.trim())
                      .map((point: string, idx: number) => (
                        <Text key={idx} fontSize={'16px'}>
                          - {point.trim()}
                        </Text>
                      ))}
                  </Text>
                </VStack>

                <VStack align="start">
                  <Text color="blue.400" fontWeight="600" fontSize={'16px'}>
                    GRAMMAR
                  </Text>
                  <Text fontSize={'16px'}>
                    {msg?.grammar
                      ?.split('-')
                      .filter((point: string) => point.trim())
                      .map((point: string, idx: number) => (
                        <Text key={idx} fontSize={'16px'}>
                          - {point.trim()}
                        </Text>
                      ))}
                  </Text>
                </VStack>

                <VStack align="start">
                  <Text color="blue.400" fontWeight="600">
                    PRONUNCIATION
                  </Text>
                  <Text fontSize={'16px'}>
                    {msg?.pronunciation
                      ?.split('-')
                      .filter((point: string) => point.trim())
                      .map((point: string, idx: number) => (
                        <Text key={idx} fontSize={'16px'}>
                          - {point.trim()}
                        </Text>
                      ))}
                  </Text>
                </VStack>
              </Grid>
            </VStack>
          </HStack>
        )
      case 'SUMMARY':
        return (
          <HStack key={index} align="start" spacing={4}>
            <Avatar
              src={AvatarDefault}
              size="sm"
              borderRadius={'50%'}
              border={'2px solid #E4E7EC'}
            />
            <VStack
              maxWidth={'80%'}
              align="start"
              spacing={4}
              bg={'white'}
              p={'16px'}
              borderRadius={'12px'}>
              <Text fontWeight={600} fontSize={'16px'}>
                Xem lại câu trả lời của bạn nhé!
              </Text>

              <Box bg="gray.50" p={4} borderRadius="md" w="full">
                <Flex justify="space-between" align="flex-start" gap={4}>
                  <Text flex="1" fontSize={'16px'}>
                    {msg?.user_answer}
                  </Text>
                  {/* <Button
                    borderColor={'#70BAFF'}
                    variant="outline"
                    color={CommonColors.primary}
                    leftIcon={
                      <Icon
                        as={isSaveSentence ? SaveTrueIcon : SaveFalseIcon}
                        w={'20px'}
                        h={'20px'}
                      />
                    }
                    flexShrink={0}
                    bg={isSaveSentence ? '#D6EBFF' : 'unset'}
                    onClick={handleSaveSentence}>
                    {isSaveSentence ? 'Đã lưu' : 'Lưu câu'}
                  </Button> */}
                </Flex>
              </Box>

              <Text color="gray.500" fontSize={'16px'}>
                Đừng quên lưu các cụm quan trọng bên dưới nhé!
              </Text>

              <VStack spacing={6} w="full" p={'16px'}>
                {msg?.chunk?.map((item: any, idx: number) => (
                  <Flex
                    key={idx}
                    w="full"
                    justify="space-between"
                    align="center">
                    <VStack align="start" spacing={0} pr={4}>
                      <Text fontWeight="600" fontSize={'16px'}>
                        {item.text_en}
                      </Text>
                      <Text fontSize={'16px'} color="gray.600">
                        {item.text_vi}
                      </Text>
                    </VStack>
                    <Button
                      borderColor={'#70BAFF'}
                      variant="outline"
                      color={CommonColors.primary}
                      bg={
                        isSave[item.text_en.replace(/ /g, '_')] ||
                        item?.is_saved
                          ? '#D6EBFF'
                          : 'unset'
                      }
                      leftIcon={
                        <Icon
                          as={
                            isSave[item.text_en.replace(/ /g, '_')] ||
                            item?.is_saved
                              ? SaveTrueIcon
                              : SaveFalseIcon
                          }
                          w={'20px'}
                          h={'20px'}
                        />
                      }
                      onClick={() => handleSavePhrase(item)}>
                      {isSave[item.text_en.replace(/ /g, '_')] || item?.is_saved
                        ? 'Đã lưu'
                        : 'Lưu cụm'}
                    </Button>
                  </Flex>
                ))}
              </VStack>
            </VStack>
          </HStack>
        )
      default:
        break
    }
  }

  return (
    <Flex flexDirection={'column'} gap={4}>
      {!isLoading &&
        messages.map((msg: any, index: number) => renderMessage(msg, index))}
      {(isLoading || isLoadingBot) && (
        <HStack align="start" spacing={4}>
          <Avatar
            src={AvatarDefault}
            size="sm"
            borderRadius={'50%'}
            border={'2px solid #E4E7EC'}
          />
          <Box bg={'white'} p={'16px'} borderRadius={'12px'}>
            <Box className="loading-message"></Box>
          </Box>
        </HStack>
      )}
      <SavePhraseForm handleAfterSuccess={handleAfterSuccess} />
    </Flex>
  )
}

export default Summary
